<template>
   <div id="wrapper">
    <div id="password-reset-component">
      <div class="bg-purple">
        <img class="logo" src="../../assets/images/logos/logo-white-live.svg" />
        <img class="page-icon" src="static/assets/icons/auth/lock.png" />
      </div>
      <div class="bg-grey text-white text-center welcome-message">
        <h4>Password Recovery</h4>
        <p>
          Sorry to hear you forgot your password. <br/>Please provide the email address for the account you wish to reset.
        </p>
      </div>
      <div class="text-center">
         <el-alert
        v-if="passwordResetSucceeded"
        title="Success"
        type="success"
        description="Your password has been reset successfully!">
      </el-alert>

      <el-alert
        v-if="passwordResetFailed"
        title="Password Reset Failed"
        type="error"
        description="We couldn't reset your password. Please contact COLONY LIVE support for further assistance.">
      </el-alert> 
      <br>
      <div v-if="!passwordResetSucceeded">
        <PasswordOnlyResetForm></PasswordOnlyResetForm>
        </div>
        <br>
        <strong>
          <div v-if="!passwordResetSucceeded">
            <router-link class="text-light-grey" :to="{ name: 'Login' }">Already have an account?</router-link>
          </div>
          <div v-else>
            <router-link class="text-light-grey" :to="{ name: 'Login' }">Login</router-link>
          </div>
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PasswordOnlyResetForm from './PasswordOnlyResetForm';

export default {
  name: 'PasswordRestWithTokenForm',
  components: {
    PasswordOnlyResetForm,
  },
  computed: {
    ...mapState('auth', [
      'passwordResetFailed',
      'passwordResetSucceeded',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

#wrapper {
  background: $white;
  height: 100%;
  width: 100%;
}

#password-reset-component {
  padding-top: 10px;
  width: 300px;
  margin: 0 auto;
}

#password-reset-btn {
  width: 100%;
  background: $colony-primary;
  border-color: $colony-primary;
  border-radius: 0;
}

.logo {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;
  display: block;
}

.page-icon {
  width: 100px;
  margin: 0 auto;
  display: block;
  padding-bottom: 20px;
}

.welcome-message {
  padding: 20px;
  margin-bottom: 20px;

  p {
    font-size: 0.7em;
    letter-spacing: 0.08em;
    line-height: 1.8em;
  }

  h4 {
    font-weight: lighter;
    font-size: 0.95em;
    margin: 0px;
    text-transform: uppercase;
    letter-spacing: 0.15em;
  }
}


</style>




// WEBPACK FOOTER //
// PasswordRestWithTokenForm.vue?f984a3d4